import { fetchJsonResponse } from '@/ai/api'
import { buildWorkflowAssistantPrompt } from '@/ai/prompts'

import moveLane from '@/api/chatGPT/chatLog/functions/moveLane.json'
import voteCard from '@/api/chatGPT/chatLog/functions/voteCard.json'
import createLane from '@/api/chatGPT/chatLog/functions/createLane.json'
import deleteLane from '@/api/chatGPT/chatLog/functions/deleteLane.json'
import createCard from '@/api/chatGPT/chatLog/functions/createCard.json'
import deleteCard from '@/api/chatGPT/chatLog/functions/deleteCard.json'
import createEvent from '@/api/chatGPT/chatLog/functions/createEvent.json'
import deleteEvent from '@/api/chatGPT/chatLog/functions/deleteEvent.json'
import createEntity from '@/api/chatGPT/chatLog/functions/createEntity.json'
import updateEntity from '@/api/chatGPT/chatLog/functions/updateEntity.json'
import deleteEntity from '@/api/chatGPT/chatLog/functions/deleteEntity.json'
import updateLaneName from '@/api/chatGPT/chatLog/functions/updateLaneName.json'
import createWriteModel from '@/api/chatGPT/chatLog/functions/createWriteModel.json'
import updateWorkflowName from '@/api/chatGPT/chatLog/functions/updateWorkflowName.json'
import updateCardDescription from '@/api/chatGPT/chatLog/functions/updateCardDescription.json'
import updateEventDescription from '@/api/chatGPT/chatLog/functions/updateEventDescription.json'

export const tools = [
  updateWorkflowName,
  createEvent,
  updateEventDescription,
  deleteEvent,
  createLane,
  updateLaneName,
  deleteLane,
  moveLane,
  createCard,
  deleteCard,
  updateCardDescription,
  voteCard,
  createEntity,
  updateEntity,
  deleteEntity,
  createWriteModel
]

export const generateWorkflowAssistant = async ({
  workflow,
  messagesHistory = [],
  prompt,
  abortController
}) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }

  const messages = buildWorkflowAssistantPrompt({
    workflow,
    messagesHistory,
    prompt
  })

  try {
    const response = await fetchJsonResponse({
      messages,
      aiVersion: workflow.aiVersion,
      tools,
      signal: abortController?.signal
    })

    return response || null
  } catch (error) {
    return null
  }
}
